import React, { Fragment } from 'react';

import LargeGrid from './LargeGrid';
import SmallGrid from './SmallGrid';

const ApprovedMeetGrid = ({data, isLoading, onApprovedRequestClicked}) => (
  <Fragment>
    <LargeGrid data={data} isLoading={isLoading} onApprovedRequestClicked={onApprovedRequestClicked}/>
    <SmallGrid data={data} isLoading={isLoading} onApprovedRequestClicked={onApprovedRequestClicked}/>
  </Fragment>
);

export default ApprovedMeetGrid;